import React, { useEffect, useState } from "react";
import HistorianDashboard from "./Historian";
import { fetcheaderinfo } from "../../services/UserRegistrationApi";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { WEB_ROLE } from "../../common/Constant";
import EditorDashboard from "./Editor";
import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import DoctorDashboard from "./Doctor";
import RecordReviewerDashboard from "./RecordReviewer";
import Invoice from "../Invoice/ManageInvoice";
import TranscriberDashboard from "./Transcriber";

const ToDos = () => {
  // const [userRole, setUserRole] = useState("");
  const userRole = localStorage.getItem("userrole") || "";
  const [showMainHeader, setShowMainHeader] = useState(true);
  const [viewInvoice, setViewInvoice] = useState(false);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  // const getloggedInUserRole = async () => {
  //   try {
  //     //const userCredentialData = await fetcheaderinfo(loggedInUserid);
  //     const userRole = localStorage.getItem("userrole") || "";
  //     if (userRole) {
  //       setUserRole(userRole);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   getloggedInUserRole();
  // }, [loggedInUserid]);

  const roles =
    userRole
      ?.split(",")
      .map((role) => role.trim())
      .filter(Boolean) || [];

  // Role checks
  const isHistorian = roles.includes(WEB_ROLE.Historian);

  const isEditor = roles.includes(WEB_ROLE.Editor);
  const isTranscriber = roles.includes(WEB_ROLE.Transcriber);

  const isDoctor =
    roles.includes(WEB_ROLE.IndependentQMEDoctor) ||
    roles.includes(WEB_ROLE.QME_Doctor);

  const isRecordReviewer = roles.includes(WEB_ROLE.Record_Reviewer);

  const handleViewInvoice = () => {
    setViewInvoice(true);
    sessionStorage.setItem(
      "todosViewInvoiceData",
      JSON.stringify({
        isToDo: true,
      }),
    );
    window.open("/#/mytodos-view-invoice", "_blank");
  };

  const handleCloseViewInvoice = () => {
    setViewInvoice(false);
  };

  return (
    <>
      {showMainHeader && (
        <div className="breadcrumbg breadcrumbgNew pb-0 pt-1">
          <Container fluid className="px-5">
            <Row className="align-items-center fade-in-left">
              <Col>
                {isHistorian && <h4>LIST OF PENDING HISTORIES</h4>}
                {isEditor && <h4>LIST OF PENDING REPORTS</h4>}
                {isRecordReviewer && <h4>LIST OF PENDING REVIEWS</h4>}
                {isDoctor && <h4>LIST OF PENDING REVIEWS</h4>}
              </Col>
              {(isHistorian ||
                isEditor ||
                isRecordReviewer ||
                isDoctor ||
                isTranscriber) && (
                <Col xs="auto" className="text-end">
                  <Button
                    className="d-flex align-items-center"
                    onClick={handleViewInvoice}
                  >
                    <span className="material-icons me-1">receipt</span>
                    View Invoice
                  </Button>
                </Col>
              )}
            </Row>
          </Container>
        </div>
      )}

      {isHistorian ? <HistorianDashboard /> : null}
      {isEditor ? (
        <EditorDashboard setShowMainHeader={setShowMainHeader} />
      ) : null}
      {isTranscriber ? (
        <TranscriberDashboard setShowMainHeader={setShowMainHeader} />
      ) : null}

      {isDoctor ? (
        <DoctorDashboard setShowMainHeader={setShowMainHeader} />
      ) : null}
      {isRecordReviewer ? (
        <RecordReviewerDashboard setShowMainHeader={setShowMainHeader} />
      ) : null}
    </>
  );
};

export default ToDos;
